
<template>
  <v-container fluid>
    <!-- <div class="headline white--text">
      Controle dos Vale Paletes
    </div> -->
    <!-- <div style="height: 90%"> -->
      <main-dash v-if="!is_tv"></main-dash>
      <main-dash-tv v-if="is_tv"></main-dash-tv>
    <!-- </div> -->
  </v-container>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'IndexPalletDash',
  components: {
    MainDash: () => import('../components/MainPallet'),
    MainDashTv: () => import('../components/MainPallet2'),
  },
  data() {
    return {
      key: null
    }
  },
  methods: {
    names() {
      
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  mounted () {
    if(this.navi.toLowerCase().includes('tv')){
      this.$router.push('dashboard?tv=true');
    }
  },
  computed: {
    navi(){
      return window.navigator.userAgent
    },
    is_tv() {
      let is_tv = this.$route.query && this.$route.query.tv == 'true'
      // console.log({is_tv});
      return is_tv
    },
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>